import { useQuery } from '@tanstack/react-query'

import { CAR_STORY_QUERY_KEYS } from '../../lib'
import { type IGetMycleContentsParams } from '../../model'
import { getMycleContents } from '../request'

const useMycleContentsQuery = ({
  menu,
  page = 0,
  size = 20,
  sort,
  categoryId,
}: IGetMycleContentsParams) =>
  useQuery({
    queryKey: CAR_STORY_QUERY_KEYS.CONTENTS.list(
      menu,
      page,
      size,
      sort,
      categoryId
    ),
    queryFn: () => getMycleContents({ menu, page, size, sort, categoryId }),
    throwOnError: false,
  })

export default useMycleContentsQuery
